import { useState, useCallback } from "react";
import { callApi } from "../../utils/apiClient";
import { API_ENDPOINTS } from "../../config/api/apiCall";


export const useParentRollDetails = (winderMONumber, winderMANumber) => {
  const [parentRollDetails, setParentRollDetails] = useState(null);
  const [lotsDetail, setLotsDetail] = useState([]);
  const [parentRollDate, setParentRollDate] = useState(null);
  const [parentRollDetailLoading, setParentRollDetailLoading] = useState(false);
  const [parentRollDetailError, setParentRollDetailError] = useState(null);

  // main function (reusable)
  const loadSelectedLotDetails = useCallback(
    async (parentRoll, status, { updateParentRollDetails, handleEdit, toggleViews,lotList }) => {
      setParentRollDetailLoading(true);
      setParentRollDetailError(null);

      try {
        const orderData = {
          p_companyid: localStorage.getItem("companyid"),
          p_pr_number: parentRoll,
        };

        const data = await callApi(
          API_ENDPOINTS.PROD_MANAGEMENT_GET_PARENT_ROLL_DETAILS,
          "POST",
          { "Content-Type": "application/json" },
          orderData
        );

        if (data?.length > 0) {
          setParentRollDetails(data[0]);
          setLotsDetail(data);
          updateParentRollDetails?.(data[0]); // callback from parent
          setParentRollDate(data[0].pr_date);
          lotList?.(data);

          if (status === "new") {
            // UI handling via callback
            toggleViews?.({
              viewWinderParentRollDetail: true,
              viewWinderParentRollPlanningDetail: false,
              viewWinderParentRollSummaryDetail: false,
            });
          } else {
            const selectedRow = data.find(
              (lot) =>
                lot.release_no === String(winderMONumber) &&
                lot.lot_no === parseInt(winderMANumber)
            );
            if (selectedRow) {
              handleEdit?.(selectedRow); // call parent handler
            }
          }
        }
      } catch (err) {
        console.error("Error loading lot details:", err);
        setParentRollDetailError(err);
      } finally {
        setParentRollDetailLoading(false);
      }
    },
    [winderMONumber, winderMANumber]
  );

  return {
    parentRollDetails,
    lotsDetail,
    parentRollDate,
    parentRollDetailLoading,
    parentRollDetailError,
    loadSelectedLotDetails,
  };
};
